import { createContext } from 'react';

import type { PublicationHandler, RealtimeStatus, Unsubscribe } from './types';

export interface RealtimeContextValue {
  status: RealtimeStatus;
  subscribe: <T>(channel: string, handler: PublicationHandler<T>) => Unsubscribe;
}

/**
 * The default IS the no-op contract: with no `VITE_CENTRIFUGO_URL` (or outside
 * a provider) `useRealtimeChannel` registers nothing and the app behaves
 * exactly as it did before realtime existed.
 */
export const RealtimeContext = createContext<RealtimeContextValue>({
  status: 'disabled',
  subscribe: () => () => {},
});
